import { render, h } from 'preact';

import loadJsonScript from '../utils/load-json-script';

import EmbedApp from '../EmbedApp';
import parseQueryString from '../utils/parse-query-string';

const { contest } = parseQueryString(location.search);

const annotations = loadJsonScript('annotations_data');
const flags = loadJsonScript('flag_data');

let selectedContests;

if (Array.isArray(contest)) {
  selectedContests = contest;
} else {
  if (contest != null) {
    selectedContests = [contest];
  } else {
    selectedContests = [];
  }
}

render(
  <EmbedApp
    selectedContests={selectedContests}
    annotations={annotations}
    flags={flags}
    embedType={'partner'}
    embedDMN={partner_dmn}
  />,
  document.getElementById('app')
);
